import {Trans, useTranslation} from 'react-i18next';
import {useTheme} from 'styled-components';
import {CustomIcon} from '@guestapp/old-ui-kit';
import {Title, Wrapper, Text, HelperText} from './styled';
import {Button} from '@chekin/guestapp-ui-kit';
import {useLayoutMode} from 'hooks/useLayoutMode';

type AutoFillProps = {
  onClose: () => void;
};

function AutoFillModalSheet({onClose}: AutoFillProps) {
  const {t} = useTranslation();
  const theme = useTheme();
  const layoutMode = useLayoutMode();
  const iconSize = layoutMode === 'default' ? 200 : 400;
  return (
    <Wrapper className="autofill-modal-sheet">
      <CustomIcon
        name="autoFill"
        custom
        size={iconSize}
        color={theme.colors.branding.primary}
        className="autofill-modal-sheet__icon"
      />
      <Title className="autofill-modal-sheet__title kiosko:text-kiosko-m kiosko:mt-[114px]">
        {t('form_auto_filled')}
      </Title>
      <Text className="autofill-modal-sheet__text kiosko:text-kiosko-s kiosko:leading-normal">
        {t('chekin_form_has_been_auto_filled')}
      </Text>
      <HelperText className="autofill-modal-sheet__helper kiosko:text-kiosko-s kiosko:leading-normal">
        <Trans i18nKey="please_check_personal_data" />
      </HelperText>
      <Button onClick={onClose} className="autofill-modal-sheet__confirm-btn">
        {t('understood')}
      </Button>
    </Wrapper>
  );
}

export {AutoFillModalSheet};
